module.exports = __webpack_public_path__ + "media/images/top-up-13b0284904c4a625f5aa55b28095589e.svg";